/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_500_LabelInputs */

const ja_error_500_label = /** @type {(inputs: Error_500_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「500エラー」`)
};

const en_error_500_label = /** @type {(inputs: Error_500_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 Error`)
};

/**
* | output |
* | --- |
* | "500 Error" |
*
* @param {Error_500_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const error_500_label = /** @type {((inputs?: Error_500_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_500_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_500_label(inputs)
	return en_error_500_label(inputs)
});